import MicrospecFlowCommonHeader from "../MicrosepcFlowUI/Components/MicrosepcFlowCommonHeader";
import MicrospecFlowCommonFooterSections from "../MicrosepcFlowUI/Components/MicrospecFlowCommonFooterSections";
import MicrospecFlowModulesProvider from "../MicrosepcFlowUI/Contexts/MicrospecFlowModulesProvider";
import { MicrospecSvgIcon } from "../MicrospecDynamicUI/Components";
import getDomain from "../MicrospecDynamicUI/Helpers/DomainParser";

const config = {
    application: {
        name: {
            type: "Localized",
            text: "application.name"
        },
        slogan: {
            type: "Localized",
            text: "application.slogan"
        },
        logo: "/static/images/microspec.svg",
        auth: {
            enableRegister: false,
            sso: {
                enabled: true,
                cookieKey: "sso_auth",
            }
        },
        commonConfig: {
            showOfflineDialog: false,
        },
        theme: {
            mode: "light", // light, dark, system
            primary: {
                main: "#0c0462",
                light: "#867ae7ff",
                dark: "#080338",
                contrastText: "#ffffff"
            },
            secondary: {
                main: "#737373",
                light: "#a6a6a6",
                dark: "#404040",
                contrastText: "#ffffff"
            },
        },
        information: {
            contactEmail: "microspective.dev@gmail.com",
            // contactPhone: "+1-234-567-890",
            address: "Main Street 203, Sakhnin, Israel",
            // socialMedia: {
            //     facebook: "https://www.facebook.com/yourcompany",
            //     twitter: "https://www.twitter.com/yourcompany",
            //     instagram: "https://www.instagram.com/yourcompany",
            //     linkedin: "https://www.linkedin.com/company/yourcompany",
            //     youtube: "https://www.youtube.com/yourcompany",
            // },
        },
    },
    pagesCommons: {
        header: {
            type: "CompositeSections",
            sections: [
                {
                    type: "SimpleContent",
                    spec: {
                        object: <MicrospecFlowCommonHeader />
                    }
                }
            ]
        },
        footer: {
            type: "Simple",
            object: <MicrospecFlowCommonFooterSections />
        }
    },
    pages: [
        {
            path: "/",
            name: {
                type: "Localized",
                text: "application.home",
            },
            spec: {
                type: "CompositeSections",
                sections: [
                    {
                        type: "HeroSectionWithScrollTrigger",
                        spec: {
                            mainTitleText: {
                                localizationObject: {
                                    type: "Localized",
                                    text: "application.name",
                                }
                            },
                            secondaryTitleText: {
                                localizationObject: {
                                    type: "Localized",
                                    text: "application.description",
                                }
                            },
                            backgroundVideoSource: "/static/videos/microspec_application_landing_page_hero_background.mp4",
                            heroVideoSource: "/static/videos/microspec_application_landing_page.mp4",
                            actionButtonText: {
                                localizationObject: {
                                    type: "Internal",
                                    text: "learnMore",
                                }
                            },
                            actionButtonBackground: "#0c0462",
                            actionButtonHref: "#features",
                            secondaryActionButtonText: {
                                localizationObject: {
                                    type: "Internal",
                                    text: "contactUs",
                                }
                            },
                            secondaryActionButtonBackground: "transparent",
                            secondaryActionButtonHref: "#contact",
                            showBottomText: false,
                        }
                    },
                    {
                        type: "SectionsDivider",
                    },
                    {
                        type: "FeatureFlow",
                        spec: {
                            id: "features",
                            mainTitleText: {
                                localizationObject: {
                                    type: "Localized",
                                    text: "home.featuresSection.title",
                                }
                            },
                            secondaryTitleTexts: [
                                {
                                    localizationObject: {
                                        type: "Localized",
                                        text: "home.featuresSection.secondaryTitle1",
                                    }
                                },
                                {
                                    localizationObject: {
                                        type: "Localized",
                                        text: "home.featuresSection.secondaryTitle2",
                                    }
                                },
                                {
                                    localizationObject: {
                                        type: "Localized",
                                        text: "home.featuresSection.secondaryTitle3",
                                    }
                                }
                            ],
                            baseFeature: {
                                // get icon from public/icons as SvgIcon
                                icon: <MicrospecSvgIcon src="/static/icons/organization.svg" sx={{ width: "75%", height: "75%" }} />,
                                title: {
                                    localizationObject: {
                                        type: "Localized",
                                        text: "home.featuresSection.organizationModule.title",
                                    }
                                },
                                description: {
                                    localizationObject: {
                                        type: "Localized",
                                        text: "home.featuresSection.organizationModule.description",
                                    }
                                },
                                color: "#0c0462",
                                actionLink: "https://workspace.microspec.io",
                                actionText: {
                                    localizationObject: {
                                        type: "Internal",
                                        text: "learnMore",
                                    }
                                },
                            },
                            childFeatures: [
                                {
                                    icon: <MicrospecSvgIcon src="/static/icons/store.svg" sx={{ width: "75%", height: "75%" }} />,
                                    title: {
                                        localizationObject: {
                                            type: "Localized",
                                            text: "home.featuresSection.ecommerceManagerModule.title",
                                        }
                                    },
                                    description: {
                                        localizationObject: {
                                            type: "Localized",
                                            text: "home.featuresSection.ecommerceManagerModule.description",
                                        }
                                    },
                                    actionLink: "https://shop.microspec.io",
                                },
                            ]
                        },
                    },
                    {
                        type: "SectionsDivider",
                    },
                    {
                        type: "SequentialFeaturesFlow",
                        spec: {
                            mainTitleText: {
                                localizationObject: {
                                    type: "Localized",
                                    text: "home.sequentialFeaturesFlow.title",
                                }
                            },
                            secondaryTitleText: {
                                localizationObject: {
                                    type: "Localized",
                                    text: "home.sequentialFeaturesFlow.secondaryTitle",
                                }
                            },
                            orientation: "vertical", // "vertical" || "horizontal"
                            animationStyle: "slide", // "fade", "slide", "scale", "pulse"
                            accentColor: "#0c0462",
                            features: [
                                {
                                    stepNumber: 1,
                                    icon: <MicrospecSvgIcon src="/static/icons/chat.svg" sx={{ width: "100%", height: "100%" }} />,
                                    title: {
                                        localizationObject: {
                                            type: "Localized",
                                            text: "home.sequentialFeaturesFlow.contactUs.title",
                                        }
                                    },
                                    description: {
                                        localizationObject: {
                                            type: "Localized",
                                            text: "home.sequentialFeaturesFlow.contactUs.description",
                                        }
                                    },
                                    highlight: {
                                        localizationObject: {
                                            type: "Localized",
                                            text: "home.sequentialFeaturesFlow.contactUs.highlight",
                                        }
                                    },
                                    actionLink: "#contact",
                                    actionText: {
                                        localizationObject: {
                                            type: "Internal",
                                            text: "contactUs",
                                        }
                                    },
                                },
                                {
                                    stepNumber: 2,
                                    icon: <MicrospecSvgIcon src="/static/icons/search.svg" sx={{ width: "100%", height: "100%" }} />,
                                    title: {
                                        localizationObject: {
                                            type: "Localized",
                                            text: "home.sequentialFeaturesFlow.ideaAssessment.title",
                                        }
                                    },
                                    description: {
                                        localizationObject: {
                                            type: "Localized",
                                            text: "home.sequentialFeaturesFlow.ideaAssessment.description",
                                        }
                                    },
                                    highlight: {
                                        localizationObject: {
                                            type: "Localized",
                                            text: "home.sequentialFeaturesFlow.ideaAssessment.highlight",
                                        }
                                    },
                                    actionLink: "#contact",
                                    actionText: {
                                        localizationObject: {
                                            type: "Internal",
                                            text: "contactUs",
                                        }
                                    },
                                },
                                {
                                    stepNumber: 3,
                                    icon: <MicrospecSvgIcon src="/static/icons/strategy.svg" sx={{ width: "100%", height: "100%" }} />,
                                    title: {
                                        localizationObject: {
                                            type: "Localized",
                                            text: "home.sequentialFeaturesFlow.customSolutionDevelopment.title",
                                        }
                                    },
                                    description: {
                                        localizationObject: {
                                            type: "Localized",
                                            text: "home.sequentialFeaturesFlow.customSolutionDevelopment.description",
                                        }
                                    },
                                    highlight: {
                                        localizationObject: {
                                            type: "Localized",
                                            text: "home.sequentialFeaturesFlow.customSolutionDevelopment.highlight",
                                        }
                                    },
                                    actionLink: "#contact",
                                    actionText: {
                                        localizationObject: {
                                            type: "Internal",
                                            text: "contactUs",
                                        }
                                    },
                                },
                                {
                                    stepNumber: 4,
                                    icon: <MicrospecSvgIcon src="/static/icons/rocket.svg" sx={{ width: "100%", height: "100%" }} />,
                                    title: {
                                        localizationObject: {
                                            type: "Localized",
                                            text: "home.sequentialFeaturesFlow.launchAndScale.title",
                                        }
                                    },
                                    description: {
                                        localizationObject: {
                                            type: "Localized",
                                            text: "home.sequentialFeaturesFlow.launchAndScale.description",
                                        }
                                    },
                                    highlight: {
                                        localizationObject: {
                                            type: "Localized",
                                            text: "home.sequentialFeaturesFlow.launchAndScale.highlight",
                                        }
                                    },
                                    actionLink: "#contact",
                                    actionText: {
                                        localizationObject: {
                                            type: "Internal",
                                            text: "contactUs",
                                        }
                                    },
                                },
                            ]
                        }
                    },
                    {
                        type: "SectionsDivider",
                    },
                    // {
                    //     type: "ModernFAQ",
                    //     spec: {
                    //         enableSearch: true,
                    //         allowMultipleExpanded: false,
                    //         faqs: [
                    //             {
                    //                 question: "ما هي الخدمات التي تقدمونها؟",
                    //                 answer: "نقدم مجموعة شاملة من الخدمات الرقمية بما في ذلك تطوير الويب، تطبيقات الهاتف المحمول، الحلول السحابية، والاستشارات التقنية. فريقنا من الخبراء مستعد لمساعدتك في تحويل أفكارك إلى واقع.",
                    //                 category: "general"
                    //             },
                    //             {
                    //                 question: "كيف أبدأ مشروعاً معكم؟",
                    //                 answer: "البدء سهل! ببساطة <strong>تواصل معنا</strong> من خلال نموذج الاتصال وسيقوم فريقنا بالتواصل معك خلال 24 ساعة لمناقشة احتياجات مشروعك ووضع خطة عمل مخصصة.",
                    //                 category: "getting-started"
                    //             },
                    //             {
                    //                 question: "ما هي مدة تنفيذ المشروع؟",
                    //                 answer: "تختلف مدة المشروع حسب التعقيد والمتطلبات. المشاريع الصغيرة قد تستغرق 2-4 أسابيع، بينما المشاريع الكبيرة قد تستغرق 3-6 أشهر. سنقدم لك جدولاً زمنياً تفصيلياً بعد تقييم متطلبات مشروعك.",
                    //                 category: "general"
                    //             },
                    //             {
                    //                 question: "هل تقدمون الدعم بعد إطلاق المشروع؟",
                    //                 answer: "نعم، نقدم دعماً شاملاً بعد الإطلاق يشمل الصيانة الدورية، التحديثات الأمنية، إصلاح الأخطاء، والدعم الفني. نوفر عدة باقات دعم لتناسب احتياجاتك.",
                    //                 category: "support"
                    //             },
                    //             {
                    //                 question: "ما هي تكلفة خدماتكم؟",
                    //                 answer: "تعتمد التكلفة على نطاق المشروع ومتطلباته. نقدم تسعيراً تنافسياً وشفافاً بدون رسوم خفية. بعد استشارة أولية مجانية، سنقدم لك عرض أسعار مفصل يناسب ميزانيتك.",
                    //                 category: "pricing"
                    //             },
                    //             {
                    //                 question: "هل يمكنني رؤية أمثلة من أعمالكم السابقة؟",
                    //                 answer: "بالتأكيد! لدينا مجموعة واسعة من المشاريع الناجحة في مختلف الصناعات. يمكنك زيارة صفحة <strong>معرض الأعمال</strong> أو التواصل معنا للحصول على دراسات حالة مفصلة متعلقة بمجال عملك.",
                    //                 category: "general"
                    //             },
                    //             {
                    //                 question: "ما هي التقنيات التي تستخدمونها؟",
                    //                 answer: "نستخدم أحدث التقنيات والأطر العمل مثل React، Node.js، Python، Cloud Services (AWS، Azure)، وقواعد البيانات المتقدمة. نختار التقنية المناسبة بناءً على متطلبات كل مشروع.",
                    //                 category: "technical"
                    //             },
                    //             {
                    //                 question: "هل تعملون مع العملاء الدوليين؟",
                    //                 answer: "نعم، نعمل مع عملاء من جميع أنحاء العالم. فريقنا متعدد اللغات ومتاح للتواصل في مناطق زمنية مختلفة لضمان التعاون السلس.",
                    //                 category: "general"
                    //             }
                    //         ],
                    //         categories: [
                    //             { id: "general", name: "عام", icon: "💬" },
                    //             { id: "getting-started", name: "البدء", icon: "🚀" },
                    //             { id: "support", name: "الدعم", icon: "🛟" },
                    //             { id: "pricing", name: "الأسعار", icon: "💰" },
                    //             { id: "technical", name: "تقني", icon: "⚙️" }
                    //         ]
                    //     }
                    // },
                ],
            },
        },
    ],
    modules: {
        //hostname
        managementLink: (getDomain(window.location.hostname) === "localhost" ?
            "" :
            "https://workspace.microspec.io") +
            "/manager/organizations/{organization_id}/modules",
    },
    dashboards: [],
    contextsProviders: [
        MicrospecFlowModulesProvider
    ],
    languages: {
        default: 'en-US',
        list: [
            { code: 'ar-SA', name: 'العربية' },
            { code: 'he-IL', name: 'עברית' },
            { code: 'en-US', name: 'English' },
            { code: 'ru-RU', name: 'Русский (Бета - Beta)' }
        ]
    }
}

export default config;